import SideBannerLayout from "layouts/SideBannerLayout";
import SignInForm from "components/SignInForm";
import { useAppMeta } from "hooks";
import banner from "assets/tmsnewpsd.png";

const SignIn = () => {
  const { appMeta } = useAppMeta();
  useAppMeta("Sign In");

  const handleLogoClick = () => {
    window.location.href = "/home";
  };

  return (
    <SideBannerLayout banner={banner}>
      <div className="flex w-full flex-col gap-6">
        <div className="text-center">
          <h2 className="mb-2 text-3xl font-semibold text-gray-700">Welcome to</h2>
          <img
            src={appMeta.logoSmall}
            alt={appMeta.title}
            className="mx-auto mb-2 h-8 cursor-pointer"
            onClick={handleLogoClick}
          />
          <p className="text-gray">
            Manage your transport operations effortlessly. Sign in to access your dashboard.
          </p>
        </div>
        <SignInForm />
      </div>
    </SideBannerLayout>
  );
};

export default SignIn;